import { Text } from 'platform-components';
import { UI_KIT_TEXT_TYPOGRAPHY } from 'platform-components/constants';
import React from 'react';
import { accessibleClick } from '@edu-frontend/modules/src/shared/lib/a11y';

import { SearchResultItem, SearchResults } from '../typings';

import './search__result.scss';

interface Props {
    onResultClick: (res: SearchResultItem) => void;
    searchResults: SearchResults;
}

export const SearchResultBySubject = ({ onResultClick, searchResults }: Props) => {
    let number = 0;

    return (
        <div>
            {Object.keys(searchResults).map((subject) => (
                <>
                    <div className="library__search-result-subject">
                        <Text typography={UI_KIT_TEXT_TYPOGRAPHY.captionXSMediumWider}>
                            {searchResults[subject].subjectName}
                        </Text>
                    </div>
                    {searchResults[subject].results.map((result) => {
                        number += 1;

                        return (
                            // Здесь onMouseDown конкретно для пользователей с мышкой,
                            // без него результаты поиска пропадают при нажатии (до обработчика клика)
                            // TODO: кажется, что скринридеру недоступны результаты поиска
                            // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                            <div
                                className="library__search-result"
                                key={result.themeId}
                                onMouseDown={(e) => e.preventDefault()}
                                {...accessibleClick(() => onResultClick({ ...result, subject, number }))}
                            >
                                <Text typography={UI_KIT_TEXT_TYPOGRAPHY.paragraphXLRegular}>{result.themeName}</Text>
                            </div>
                        );
                    })}
                </>
            ))}
        </div>
    );
};
